import { IProcessEquipmentData } from "shared/api/api";
import { Syncable } from "shared/state/models/syncable";

export const GET_ProcessEquipmentData = 'GET_ProcessEquipmentData';
export const SAVE_ProcessEquipmentData = 'SAVE_ProcessEquipmentData';
export const SAVE_ProcessEquipmentDataFromUnitToPen = 'SAVE_ProcessEquipmentDataFromUnitToPen'
export const SYNC_DATA_PROCESS_EQUIPMENT_DATA = 'SYNC_DATA_PROCESS_EQUIPMENT_DATA'
export interface ProcessEquipmentDataState extends Syncable<IProcessEquipmentData> { 
}
